import { Grid, DialogActions, DialogContent, Button, Typography } from '@mui/material';
import { DialogCustom, DialogTitleCustom, FieldWrap, MdView } from '@tap/mui-ui';
import { IApiComment, commentService, userService } from '@tap/data-providers';
import { useState } from 'react';
import { ICancelDialogResult, IDialogProps } from '@tap/tap-ui';
import { dateTimeHelper } from '@tap/utils';

/**
 *  Диалог: удалить комментарий
 */

type IDeleteCommentDialogProps = IDialogProps<{
    comment: IApiComment,
    deleteCommentCallback: () => void,
}, ICancelDialogResult>;

export const DeleteCommentDialog = ({
    data,
    isOpen,
    handleClose,
}: IDeleteCommentDialogProps) => {

    const [isDeleted, setIsDeleted] = useState<boolean>(false);

    const handleDeleteComment = async () => {
        try {
            setIsDeleted(true);
            await commentService.deleteComment(data.comment.id);
            data.deleteCommentCallback && data.deleteCommentCallback();
            handleClose({ isCancel: true });
        } catch (error) {
            console.log(error)
        } finally {
            setIsDeleted(false);
        }
    }

    const handleCancel = () => {
        handleClose({ isCancel: true });
    }


    return (
        <DialogCustom
            handleClose={handleCancel}
            open={isOpen}
        >

            <DialogTitleCustom
                primaryText={'Удалить комментарий'}
            />

            <DialogContent>

                <Grid container spacing={2}>

                    <FieldWrap label={'Автор'}>
                        <Typography>
                            {data.comment?.author
                                ? userService.getUserFIO(data.comment.author)
                                : data.comment.authorId
                            }
                        </Typography>
                    </FieldWrap>

                    <FieldWrap label={'Создан'}>
                        <Typography>
                            {dateTimeHelper.format(data.comment.createdAtUtc, 'dd MMM yyyy в HH:mm', true)}
                        </Typography>
                    </FieldWrap>

                    <FieldWrap
                        label={'Комментарий'}
                        wrapLabelStyle={{
                            verticalAlign: 'top',
                        }}
                    >
                        <MdView mdContent={data.comment.message || ''} />
                    </FieldWrap>

                </Grid>

            </DialogContent>

            <DialogActions>
                <Grid container justifyContent='flex-end'>

                    <Button
                        disabled={isDeleted}
                        disableElevation
                        type='button'
                        variant='contained'
                        color='primary'
                        sx={{ mr: 2 }}
                        onClick={() => handleDeleteComment()}
                    >
                        Удалить
                    </Button>

                    <Button
                        disableElevation
                        type='button'
                        variant='text'
                        color='primary'
                        onClick={handleCancel}
                    >
                        Отмена
                    </Button>

                </Grid>
            </DialogActions>

        </DialogCustom >
    );
}
